import { render, staticRenderFns } from "./vt-horizontal-list-item.vue?vue&type=template&id=c0cbd9ae&scoped=true&"
import script from "./vt-horizontal-list-item.vue?vue&type=script&lang=ts&"
export * from "./vt-horizontal-list-item.vue?vue&type=script&lang=ts&"
import style0 from "./vt-horizontal-list-item.vue?vue&type=style&index=0&id=c0cbd9ae&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0cbd9ae",
  null
  
)

export default component.exports